export function convertToCSV (objArray) {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
  let str = ''

  for (let i = 0; i < array.length; i++) {
    let line = ''
    for (const index in array[i]) {
      if (line !== '') line += ','

      let value = array[i][index]

      if (value === null) {
        value = ''
      } else {
        value = value.replaceAll('"', '""') // escape for csv
      }

      line += `"${value}"`
    }

    str += line + '\r\n'
  }

  return str
}

function exportCSVFile (headers, items, fileTitle) {
  if (headers) items.unshift(headers)

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items)

  const csv = convertToCSV(jsonObject)

  const exportedFileName = fileTitle + '.csv' || 'export.csv'

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFileName)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFileName)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default exportCSVFile
